/**
 * Exports a "whisper" logger instance.
 * See the @ally/whisper package's README.md for more information.
 */

import logger from '@ally/whisper'

export default logger({
  silent: process.env.NODE_ENV === 'test',
  nameSpace: '@ally/ally-next-remote-login',
})
